import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Select,
  MenuItem,
  OutlinedInput, 
} from '@mui/material';
import { format, isValid, isAfter } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import DateRangeView from './dateRangeView';

const RecurringView = ({
  isDisabled,
  start,
  setStart,
  end,
  setEnd,
  recurring,
  setRecurring,
  recurringInterval,
  setRecurringInterval,
  userTimeZone,
  providerUser
}) => { 
  const [dateError, setDateError] = useState(''); 

  // Time zone formatting function
  const formatDateToLocal = (date) => {
    return date ? format(utcToZonedTime(date, userTimeZone), 'yyyy-MM-dd') : '';
  };

  // Handle changes in the "Starts" date field
  const handleStartDateChange = (e) => {
    const userInputDate = e.target.value;
    const localStartDate = new Date(userInputDate);

    if (!isValid(localStartDate)) {
      setDateError('Invalid start date.');
      return;
    }

    const utcStartDate = zonedTimeToUtc(localStartDate, userTimeZone).toISOString();
    setStart(utcStartDate);

    if (end && isAfter(localStartDate, new Date(end))) {
      setDateError('End date cannot be before the start date.');
    } else {
      setDateError('');
    }
  };

  // Handle changes in the "Ends" date field
  const handleEndDateChange = (e) => {
    const userInputDate = e.target.value;
    const localEndDate = new Date(userInputDate);

    if (!isValid(localEndDate)) {
      setDateError('Invalid end date.');
      return;
    }

    const utcEndDate = zonedTimeToUtc(localEndDate, userTimeZone).toISOString();

    if (utcEndDate >= start) {
      setEnd(utcEndDate);
      setDateError('');
    } else {
      setDateError('End date cannot be before the start date.');
    }
  };

  // Toggle indefinite end
  const getPluralLabel = (unit) => {
    return recurringInterval > 1 ? `${unit}s` : unit; // Append 's' for plural
  };
 

  // Render component
  return (
    <Grid container spacing={2} alignItems="center">
      {/* Recurring Interval */}
      <Grid item xs={12} sm={4} md={2}>
        <Typography>Repeat every</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={2.5}>
        <OutlinedInput
          disabled={isDisabled}
          type="number"
          value={recurringInterval}
          onChange={(e) => setRecurringInterval(e.target.value)}
          onBlur={() => setRecurringInterval((val) => Math.max(1, val))}
          fullWidth
          inputProps={{ min: 1 }}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderBottom: '2px solid lightgray',
            },
          }}
        />

      </Grid>
      <Grid item xs={8} sm={4} md={4}>
        <Select
          disabled={isDisabled}
          value={recurring}
          onChange={(e) => setRecurring(e.target.value)}
          fullWidth
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderBottom: '2px solid lightgray',
            },
          }}
        >
          <MenuItem value="day">{getPluralLabel('day')}</MenuItem>
          <MenuItem defaultValue value="week">{getPluralLabel('week')}</MenuItem>
          <MenuItem value="month">{getPluralLabel('month')}</MenuItem>
          <MenuItem value="year">{getPluralLabel('year')}</MenuItem>
        </Select>
      </Grid>

      {/* Start Date */}
      <Grid container item xs={12} alignItems="center" spacing={2}>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <DateRangeView
            isDisabled={isDisabled}
            start={start}
            setStart={setStart}
            end={end}
            setEnd={setEnd}
            providerUser={providerUser}
            userTimeZone={userTimeZone}
          />
          {/* <TextField
            label="Start Date"
            type="date"
            value={formatDateToLocal(start)}
            onChange={handleStartDateChange}
            variant="outlined"
            disabled={isDisabled}
            fullWidth
            InputProps={{
              sx: { maxWidth: '300px' },
            }}
            sx={{
              borderRadius: '8px',
              '& .MuiInputBase-root': { color: '#333' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: '#ccc', borderRadius: '8px' },
                '&:hover fieldset': { borderColor: '#888' },
                '&.Mui-focused fieldset': { borderColor: '#4caf50' },
              },
            }}
            InputLabelProps={{
              sx: { color: '#333' },
            }}
          /> */}
          {dateError && (
            <Typography variant="body2" color="error">
              {dateError}
            </Typography>
          )}
        </Grid>
      </Grid>

      {/* End Date Options */}

    </Grid>
  );
};

export default RecurringView;
